import React from 'react';
import PropTypes from 'prop-types';

function Label({ children, ...props }) {
  const { isRequired, isSubfield, ...rest } = props;

  const weightStyles = isSubfield ? 'font-normal' : 'font-semibold';

  return (
    <label className='label my-1 py-0' {...rest}>
      <span className={`label-text text-base ${weightStyles}`}>
        {children}
        {isRequired && ' *'}
      </span>
    </label>
  );
}

Label.propTypes = {
  children: PropTypes.node,
  isRequired: PropTypes.bool,
  isSubfield: PropTypes.bool,
};

Label.defaultProps = {
  isRequired: false,
  isSubfield: false,
};
export default Label;
